import React from 'react';

interface ModalBackdropProps extends React.HTMLAttributes<HTMLDivElement> {
  onDismiss: () => void;
  dismissDisabled?: boolean;
}

/**
 * Dismisses only when a press starts on the backdrop.
 * Dragging from modal content onto the backdrop must never close the modal.
 */
export function ModalBackdrop({
  onDismiss,
  dismissDisabled = false,
  children,
  ...props
}: ModalBackdropProps) {
  return (
    <div
      {...props}
      className={`responsive-modal-backdrop ${props.className || ''}`}
      onMouseDown={event => {
        if (!dismissDisabled && event.target === event.currentTarget) onDismiss();
      }}
    >
      {children}
    </div>
  );
}
